import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export const generatePDF = async ({ heading1, heading2, heading3, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        [{ text: heading1, style: 'header', colSpan: 11, alignment: 'center' }, 
                         {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading2, style: 'subheader_one', colSpan: 11, alignment: 'center' }, 
                         {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading3, style: 'subheader_two', colSpan: 11, alignment: 'center' },
                         {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        
                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};




//Total No. of Pending DSL Report PDF
export const genGetASICountPendencyReportPDF = async ({ heading1, heading2, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        [{ text: heading1, style: 'header', colSpan: 4, alignment: 'center' },
                        {}, {}, {}],
                        [{ text: heading2, style: 'subheader_one', colSpan: 4, alignment: 'center' },
                        {}, {}, {}],
                        

                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};



//Total No. of New Pending DSL Report
export const GetASICountPendencyReportNewPDF = async ({ heading1, heading2, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        [{ text: heading1, style: 'header', colSpan: 6, alignment: 'center' },
                        {}, {}, {}, {}, {}],
                        [{ text: heading2, style: 'subheader_one', colSpan: 6, alignment: 'center' },
                        {}, {}, {}, {}, {}],
                        

                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};


//Pendency Report For District
export const GetASIPendencyReportDistrictPDF = async ({ heading1, heading2, heading3, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        [{ text: heading1, style: 'header', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading2, style: 'subheader_one', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading3, style: 'subheader_two', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};


//Pendency Report For Mandal
export const GetASIPendencyReportMandalPDF = async ({ heading1, heading2, heading3, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        [{ text: heading1, style: 'header', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading2, style: 'subheader_one', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading3, style: 'subheader_two', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};


//ASI- Pendency Report For HQ
export const GetASIPendencyReportHQPDF = async({ heading1, heading2, heading3,heading4, headerEnglishColumns, pdfData, width, PDFFileName }) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points (1 inch = 72 points)
            height: 141.63 * 72, // Convert inches to points (1 inch = 72 points)
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                        [{ text: heading1, style: 'header', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading2, style: 'subheader_one', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading3, style: 'subheader_two', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                        [{ text: heading4, style: 'subheader_two', colSpan: 19, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

                        [...headerEnglishColumns.map((text) => ({
                            text: text,
                            alignment: 'center',
                            bold: true,
                            fontSize: 15,
                        }))],
                        ...pdfData.map(row => row.map((cell) => ({
                            text: cell || '',
                            fontSize: 12,
                            bold: true,
                            alignment: 'center',
                        }))),
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red'
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            }
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};

//ASI- Rejected DSL Report PDF
export const GetASIRejectedDSLReportPDF = async ({
    heading1,
    heading2,
    heading3,
    headerEnglishColumns,
    pdfData,
    width,
    PDFFileName,
}) => {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    const columnsCount = Array.isArray(headerEnglishColumns)
        ? headerEnglishColumns.length
        : 0;
    const safeWidths = Array.isArray(width) && width.length === columnsCount
        ? width
        : new Array(columnsCount).fill('*');

    const makeHeadingRow = (text, style) => {
        const row = new Array(columnsCount).fill({});
        row[0] = { text, style, colSpan: columnsCount, alignment: 'center' };
        return row;
    };

    const headerRow = (headerEnglishColumns || []).map((text) => ({
        text: text,
        alignment: 'center',
        bold: true,
        fontSize: 15,
    }));

    const dataRows = (pdfData || []).map((row) => {
        const normalized = Array.from({ length: columnsCount }, (_, i) => (row && row[i]) || '');
        return normalized.map((cell) => ({
            text: cell,
            fontSize: 12,
            bold: true,
            alignment: 'center',
        }));
    });

    const documentDefinition = {
        pageSize: {
            width: 20.14 * 80, // Convert inches to points
            height: 141.63 * 72, // Convert inches to points
        },
        pageOrientation: 'portrait',
        content: [
            {
                table: {
                    headerRows: 4,
                    widths: safeWidths,
                    body: [
                        makeHeadingRow(heading1, 'header'),
                        makeHeadingRow(heading2, 'subheader_one'),
                        makeHeadingRow(heading3, 'subheader_two'),
                        headerRow,
                        ...dataRows,
                    ],
                },
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
                color: 'red',
            },
            subheader_one: {
                fontSize: 15,
                alignment: 'center',
                color: 'black',
            },
            subheader_two: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                color: 'black',
            },
        },
    };

    pdfMake.createPdf(documentDefinition).download(PDFFileName);
};